package one.devsbox.www.ui.devices

import one.devsbox.shared.ads.DeviceType
import one.devsbox.www.www_portal.generated.resources.*
import org.jetbrains.compose.resources.StringResource

fun DeviceType.label(): StringResource = when (this) {
    DeviceType.INDOOR -> Res.string.ui_devices_listing_type_indoor
    DeviceType.OUTDOOR -> Res.string.ui_devices_listing_type_outdoor
}
